import { useState, useEffect } from "react";
import {
  TrashIcon,
  EyeIcon,
  UserIcon,
  CheckIcon,
  ExclamationCircleIcon,
} from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import IzborPaketa from "./IzborPaketa";

let SviPaketi = () => {
  const [allImage, setAllImage] = useState(null); //Za sve neaktivne
  const [aktivan, setAktivan] = useState(null); //Za jedan aktivan
  const navigate = useNavigate();
  const kupiPaket = () => navigate("/dash/probaProfNav");
  const { id, email } = useAuth();

  const [status, setStatus] = useState(null); //Za cancel status
  const [isCancelationModal, setIsCancelationModal] = useState(false);

  //Za cancelation
  const [responseMessage, setResponseMessage] = useState("");
  const [loading, setLoading] = useState(false);
  // const [recordId, setRecordId] = useState("");
  // const [responseMessage, setResponseMessage] = useState(""); // Poruka o odgovoru
  // const [loading, setLoading] = useState(false); // Indikator učitavanja

  const getPakete = async () => {
    // - work here
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/get-pakete/${id}`
      );
      const result = await response.json();
      // let active = result.data.find((a) => a.status === "Aktivan"); //Uzimam poslednji u bazi koji je aktivan...
      // let notactive = result.data.filter((a) => a.status === "Neaktivan");
      setAktivan(result.data);
      // setAllImage(notactive);
      // console.log("result", result);
    } catch (error) {
      console.error("Greška prilikom učitavanja paketa:", error);
    }
  };

  useEffect(() => {
    getPakete();
  }, []);

  useEffect(() => {
    getPakete();
  }, [status]);

  function formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB").replace(/\//g, "/"); // YYYY/MM/DD
  }

  //Za otkazivanje pretplate (recurring) - MORAMO DA POSALJEMO NA SEM SERVERU JER TAKO NEMAMO CORS!
  const sendXmlRequest = async (setStatus) => {
    setLoading(true);
    const url = `${process.env.REACT_APP_API_URL}/proxy`;

    //Name => Merchent name, pass => clientid => merchent id
    //Promeni pass !!!!!!
    //Produkcija = ZZ7S6bJ3LAcEKgt
    //Dev = 6Vhju7kj47Q8pjV

    const xmlData = `<?xml version="1.0" encoding="UTF-8"?>
    <CC5Request>
        <Name>DMVadmin</Name>
        <Password>${process.env.REACT_APP_API_CANCEL}</Password>
        <ClientId>13IN003415</ClientId>
        <Extra>
            <RECURRINGOPERATION>Cancel</RECURRINGOPERATION>
            <RECORDTYPE>Recurring</RECORDTYPE>
            <RECORDID>${aktivan?.recurringID}</RECORDID>
        </Extra>
    </CC5Request>`;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: xmlData,
          user: { id, tranId: aktivan.TransId, email, aktivan },
        }),
      });

      if (!response.ok) {
        // throw new Error(`HTTP error! status: ${response.status}`);
        alert(
          `${response.status} Greska pri otkazivanju paketa, kontaktirajte korisnicku sluzbu office@nutritrans.com`
        );
      }

      const responseText = await response.text();

      // console.log("Response from server:", response);
      // console.log("Response from server - text:", responseText);

      setStatus({ success: true, message: "Request successful!" });

      //Slanje da se upise datum za otkazivanje
      const urlDatumOtk = `${process.env.REACT_APP_API_URL}/datumOtkazivanjaRecurringPaketa`;

      const responseDtumOtkaz = await fetch(urlDatumOtk, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user: { tranId: aktivan.TransId },
        }),
      });

      if (!responseDtumOtkaz.ok) {
        alert(
          `${responseDtumOtkaz.status} Greska pri azuriranju datuma otkazivanja paketa, kontaktirajte korisnicku sluzbu office@nutritrans.com`
        );
      }

      window.location.reload(); // Reload the page to see the changes
    } catch (error) {
      console.error("Error sending XML request:", error);
      setStatus({
        success: false,
        message: "Request failed: " + error.message,
      });
    }
  };

  let removePaket = () => {
    setStatus(null);
    setIsCancelationModal(false);
  };

  return (
    <>
      {/* Aktivan paket */}
      <div className="bg-white py-12 sm:py-14">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto max-w-4xl sm:text-center">
            <h2 className="text-pretty text-5xl font-semibold tracking-tight text-gray-900 sm:text-balance sm:text-6xl">
              Vaši paketi
            </h2>
            {/* <p className="mx-auto mt-6 max-w-2xl text-pretty text-lg font-medium text-gray-500 sm:text-xl/8">
              Na ovoj stranici možete videti sve svoje aktivne i neaktivne
              pakete. Možete imati samo jedan aktivan paket i koristiti njegove
              opcije, a on će biti istaknut odmah ispod. Neaktivne pakete možete
              pregledati i izbrisati, ukoliko to želite.
            </p> */}
            <p className="mx-auto mt-6 max-w-2xl text-pretty text-lg font-medium text-gray-500 sm:text-xl/8">
              Ovde možete videti sve svoje pakete – aktivni će biti istaknut
              ispod, dok neaktivne možete pregledati i obrisati.
            </p>
          </div>

          {/* <div className="mx-auto mt-16 max-w-2xl rounded-3xl ring-1 ring-gray-200 sm:mt-20 lg:mx-0 lg:flex lg:max-w-none">
                    <div className="p-1 sm:p-4 lg:flex-auto">
                        <h3 className="mt-3 text-3xl font-semibold tracking-tight text-gray-900">
                            {aktivan?.naziv_paketa} - {aktivan?.status}
                        </h3>
                        <p className="mt-2 text-base/7 text-gray-600">
                        Ovo je Vaš aktivan paket plaćen u trajanju od <span className="text-green-500">{formatDate(aktivan?.datum_placanja)}</span> do <span className="text-green-500">{formatDate(aktivan?.datum_isteka)}</span>.
                        </p>
                        <p className="mt-1 text-base/7 text-gray-600">
                            Tip paketa: <span className="text-green-500">{aktivan?.tip}</span>
                        </p>
                        <p className="mt-1 text-base/7 text-gray-600">
                            Cena: <span className="text-green-500">{aktivan?.cena}</span> RSD
                        </p>
                    </div>


                    <div className="-mt-2 p-2 lg:mt-0 lg:w-full lg:max-w-md lg:shrink-0">
                        <div className="rounded-2xl bg-gray-50 py-2 text-center ring-1 ring-inset ring-gray-900/5 lg:flex lg:flex-col lg:justify-center">
                            <div className="mx-auto max-w-xs px-8">
                                <p className="text-base font-semibold text-gray-600">Preostalo izvestaja</p>
                                <p className="mt-3 flex items-baseline justify-center gap-x-2">
                                    <div className="w-16 h-16 text-black flex flex-col items-center justify-center font-semibold rounded-2xl ring-1 ring-gray-200">
                                            <p className="text-xs font-semibold text-black">Full</p>
                                            {aktivan?.broj.full}
                                    </div>
                                    <div className="w-16 h-16 text-black flex flex-col items-center justify-center font-semibold rounded-2xl ring-1 ring-gray-200">
                                            <p className="text-xs font-semibold text-black">Osnovni</p>
                                            {aktivan?.broj.base}
                                    </div>
                                </p>
                                <a href="#" className="mt-3 block w-full rounded-md bg-red-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600">
                                    Deaktiviraj
                                </a>
                            </div>
                        </div>
                    </div>
                </div> */}

          <div className="mx-auto mt-16 max-w-2xl rounded-3xl ring-1 ring-gray-200 sm:mt-20 lg:mx-0 lg:flex lg:max-w-none">
            {/* <div className="p-1 sm:p-4 lg:flex-auto">
                    {aktivan ? (
                            <>
                            <h3 className="mt-3 text-3xl font-semibold tracking-tight text-gray-900">
                                {aktivan?.naziv_paketa} - {aktivan?.status}
                            </h3>
                            <p className="mt-2 text-base text-gray-600">
                                Ovo je Vaš aktivan paket plaćen u trajanju od <span className="text-green-500">{formatDate(aktivan?.datum_placanja)}</span> do <span className="text-green-500">{formatDate(aktivan?.datum_isteka)}</span>.
                            </p>
                            <p className="mt-1 text-base text-gray-600">
                                Tip paketa: <span className="text-green-500">{aktivan?.tip}</span>
                            </p>
                            <p className="mt-1 text-base text-gray-600">
                                Cena: <span className="text-green-500">{aktivan?.cena}</span> RSD
                            </p>
                            </>
                        ) : (
                            <div className="flex items-center justify-center bg-gray-100 p-4 rounded-lg shadow-md mt-3">
                            <ExclamationCircleIcon className="h-12 w-12 text-red-600 mr-4" />
                            <div>
                              <p className="text-xl font-semibold text-gray-800">
                                Trenutno nemate aktivan paket
                              </p>
                              <p className="text-base text-gray-600 mt-2">
                                Molimo vas da se pretplatite kako biste uživali u svim pogodnostima.
                              </p>
                            </div>
                          </div>
                        )}
                    </div> */}

            <div className="p-1 sm:p-2 lg:flex-auto rounded-2xl bg-gray-50 ring-1 ring-gray-900/5">
              {aktivan ? (
                <>
                  <h3 className="mt-3 text-3xl font-semibold tracking-tight text-gray-900">
                    {aktivan?.naziv_paketa} - {aktivan?.status}
                  </h3>

                  {/* <p className="mt-2 text-base text-gray-600">
                    Ovo je Vaš aktivan paket plaćen u trajanju od{" "}
                    <span className="text-green-500">
                      {formatDate(aktivan?.datum_placanja)}
                    </span>{" "}
                    {aktivan?.tip == "Mesečno" ? (
                      <span className="text-green-500">daljnjeg.</span>
                    ) : (
                      <span className="text-green-500">
                        do {formatDate(aktivan?.datum_isteka)}.
                      </span>
                    )}
                  </p> */}

                  <p className="mt-2 text-base text-gray-600">
                    Vaš aktivni paket je uspešno aktiviran{" "}
                    <span className="text-green-500">
                      {formatDate(aktivan?.datum_placanja)}
                    </span>{" "}
                    {aktivan?.tip == "Mesečno" ? (
                      <span className="text-green-500">
                        i ostaje važeći dok ne dođe do izmene ili otkazivanja.
                      </span>
                    ) : (
                      <span className="text-green-500">
                        do {formatDate(aktivan?.datum_isteka)}.
                      </span>
                    )}
                  </p>

                  {aktivan?.tip == "Mesečno" && (
                    <p className="mt-1 text-base text-gray-600">
                      <span className="text-green-500">
                        Biće vam naplaćeno na kraju meseca
                      </span>
                    </p>
                  )}

                  <p className="mt-1 text-base text-gray-600">
                    Tip paketa:{" "}
                    <span className="text-green-500">{aktivan?.tip}</span>
                  </p>
                  <p className="mt-1 text-base text-gray-600">
                    Cena:{" "}
                    <span className="text-green-500">{aktivan?.cena}</span> RSD
                  </p>
                </>
              ) : (
                <div className="flex items-center justify-center bg-gray-100 p-6 rounded-lg w-full h-full">
                  <ExclamationCircleIcon className="h-16 w-16 text-red-600 mr-6" />
                  <div>
                    <p className="text-xl font-semibold text-gray-800">
                      Trenutno nemate aktivan paket
                    </p>
                    <p className="text-base text-gray-600 mt-2">
                      Molimo Vas da se pretplatite kako biste uživali u svim
                      pogodnostima.
                    </p>
                  </div>
                </div>
              )}
            </div>

            {aktivan && (
              <div className="-mt-2 p-2 lg:mt-0 lg:w-full lg:max-w-md lg:shrink-0">
                <div className="rounded-2xl bg-gray-50 py-2 text-center ring-1 ring-inset ring-gray-900/5 lg:flex lg:flex-col lg:justify-center">
                  <div className="mx-auto max-w-xs px-8">
                    <p className="text-base font-semibold text-gray-600">
                      Preostalo izveštaja
                    </p>
                    <p className="mt-3 flex items-baseline justify-center gap-x-2">
                      <div className="w-16 h-16 text-black flex flex-col items-center justify-center font-semibold rounded-2xl ring-1 ring-gray-200">
                        {/* <p className="text-xs font-semibold text-black">Full</p> */}
                        {aktivan?.broj?.full}
                      </div>
                      {/* <div className="w-16 h-16 text-black flex flex-col items-center justify-center font-semibold rounded-2xl ring-1 ring-gray-200">
                        <p className="text-xs font-semibold text-black">
                          Osnovni
                        </p>
                        {aktivan?.broj?.base}
                      </div> */}
                    </p>
                    {aktivan?.tip == "Mesečno" ? (
                      <button
                        // onClick={() => sendXmlRequest(setStatus)}
                        onClick={() => setIsCancelationModal(true)}
                        disabled={loading}
                        className="mt-3 block w-full rounded-md bg-red-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
                      >
                        {loading ? "Deaktivacija u toku..." : "Deaktiviraj"}
                      </button>
                    ) : (
                      <a className="mt-3 block w-full rounded-md bg-green-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"></a>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* RESPONSE DISPLAY ZA STATUS CANCELOVANJA RECCURING OPCIJE */}
          {status && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50">
              <div className="bg-white rounded-lg shadow-xl w-96 p-6 relative">
                <button
                  onClick={() => removePaket()}
                  className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
                >
                  &#x2715;
                </button>
                <div className="text-center">
                  <h2
                    className={
                      status.success
                        ? "text-green-600 text-xl font-semibold"
                        : "text-red-600 text-xl font-semibold"
                    }
                  >
                    {status.success
                      ? "Usepšno ste otkazali pretplatu!"
                      : "Otkazivanje nije uspelo!"}
                  </h2>
                  {/* <p className="mt-2 text-gray-700">
                                    {status.message}
                                </p> */}
                </div>
                {/* <div className="mt-4 flex justify-center">
                                <button
                                    onClick={() => setStatus(null)}
                                    className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                                >
                                    Close
                                </button>
                            </div> */}
              </div>
            </div>
          )}

          {/* Warning za cancelovanje WROK HERE*/}
          {isCancelationModal && (
            <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center">
              <div className="relative p-5 border w-96 shadow-lg rounded bg-white">
                <div className="mt-3 text-center">
                  <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100">
                    <svg
                      className="h-6 w-6 text-yellow-600"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                      />
                    </svg>
                  </div>
                  <h3 className="text-lg leading-6 font-medium text-gray-900 mt-5">
                    Upoznorenje
                  </h3>
                  <div className="mt-2 px-7 py-3">
                    <p className="text-sm text-gray-500">
                      Ako deaktivirate svoj paket, svi neiskorišćeni izveštaji
                      biće trajno izgubljeni i nećete moći da im pristupite
                      kasnije. Preporučujemo da ih iskoristite pre deaktivacije
                      kako biste izvukli maksimum iz svog paketa.
                    </p>
                  </div>
                  <div className="items-center px-4 py-3">
                    <button
                      onClick={() => sendXmlRequest(setStatus)}
                      className="px-4 py-2 bg-red-500 text-white text-base font-medium rounded w-full shadow-sm hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-300"
                    >
                      Deaktiviraj
                    </button>
                    <button
                      onClick={() => setIsCancelationModal(false)}
                      className="mt-3 px-4 py-2 bg-white text-gray-800 text-base font-medium rounded w-full shadow-sm border border-gray-300 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-300"
                    >
                      Ugasi
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* <div className="-mt-1 p-1 lg:mt-0 lg:w-full lg:max-w-xs lg:shrink-0">
                    <div className="rounded-2xl bg-gray-50 py-1 text-center ring-1 ring-inset ring-gray-900/5 lg:flex lg:flex-col lg:justify-center">
                        <div className="mx-auto max-w-xs px-4">
                            <p className="text-xs font-semibold text-gray-600">Preostalo izveštaja</p>
                            <p className="mt-2 flex items-baseline justify-center gap-x-1">
                                <div className="w-8 h-8 text-black flex flex-col items-center justify-center font-semibold rounded ring-1 ring-gray-200">
                                    <p className="text-xs font-semibold text-black">Full</p>
                                    1
                                </div>
                                <div className="w-8 h-8 text-black flex flex-col items-center justify-center font-semibold rounded ring-1 ring-gray-200">
                                    <p className="text-xs font-semibold text-black">Osnovni</p>
                                    3
                                </div>
                            </p>
                            <a href="#" className="mt-2 block w-full rounded-md bg-red-600 px-2 py-1 text-center text-xs font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600">
                                Deaktiviraj
                            </a>
                        </div>
                    </div>
                </div> */}
        </div>
      </div>

      {/* Neaktivni paketi i kupi paket */}
      {/* <div className="-ml-4 -mt-2 flex flex-wrap items-center justify-between sm:flex-nowrap">
        <div className="ml-4 mt-2">
          <div className="flex items-center space-x-2">
            <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
              Kupovina paketa
            </h3>
          </div>
        </div>
        <div className="ml-4 mt-2 flex-shrink-0">
          <button
            type="button"
            onClick={kupiPaket}
            className="relative inline-flex items-center rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
          >
            Kupi paket
          </button>
        </div>
      </div> */}

      <div className="Neaktivni-planovi mt-4">
        <IzborPaketa />

        {/*TABELA PAKETA <h4>Otpremljeni izveštaji:</h4> */}
        {/* {allImage && allImage.length > 0 ? (
          <div className="overflow-x-auto">
            <table className="min-w-full border-collapse border border-gray-300">
              <thead className="bg-gray-100">
                <tr>
                  <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                    Naziv
                  </th>
                  <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                    Tip
                  </th>
                  <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                    Datum placanja
                  </th>
                  <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                    Datum isteka
                  </th>
                  <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                    Full izveštaj
                  </th>
                  <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                    Osnovni izveštaj
                  </th>
                  <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                    Cena
                  </th>
                  <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                    Valuta
                  </th>
                  <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                    Status
                  </th>
                  <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                    Akcije
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white">
                {allImage
                  .slice()
                  .reverse()
                  .map((data) => (
                    <tr key={data._id}>
                      <td className="border-b border-r px-4 py-2 text-sm text-gray-900 whitespace-nowrap">
                        {data?.naziv_paketa}
                      </td>
                      <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                        {data?.tip}
                      </td>
                      <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                        {formatDate(data?.datum_placanja)}
                      </td>
                      <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                        {formatDate(data?.datum_isteka)}
                      </td>
                      <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                        {data?.broj?.full}
                      </td>
                      <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                        {data?.broj?.base}
                      </td>
                      <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                        {data?.cena}
                      </td>
                      <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                        {data?.valuta}
                      </td>
                      <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                        {data?.status}
                      </td>
                      <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                        <div className="flex items-center space-x-4">
                          <button className="text-red-600 hover:text-red-800">
                            <TrashIcon className="h-5 w-5" aria-hidden="true" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            <br />
          </div>
        ) : (
          <p>Nema otpremljenih paketa.</p>
        )} */}
      </div>
      <br />
      <br />
      <br />
      <br />
    </>
  );
};

export default SviPaketi;
